import { RootState } from 'common/redux/core/root.reducer';

export const getArchiveList = (state: RootState) => state.archive.archiveList.data?.data || [];
export const getArchiveListStatus = (state: RootState) => state.archive.archiveList.status;
export const getArchiveListPagination = (state: RootState) =>
    state.archive.archiveList.data?.pagination;

export const getRestoredData = (state: RootState) => state.archive.dataToBeRestored;

export const getSearchList = (state: RootState) => state.archive.searchList.data?.data || [];
export const getSearchListStatus = (state: RootState) => state.archive.searchList.status;
export const getSearchListPagination = (state: RootState) =>
    state.archive.searchList.data?.pagination;

export const getHierarchicalDataSelector = (state: RootState) =>
    state.archive.hierarchicalData.data?.data || [];

export const getHierarchicalDataResponse = (state: RootState) => state.archive.hierarchicalData;

export const getRestoreDataApiStatus = (state: RootState) => state.archive.restoreData.status;

export const getReviewStatus = (state: RootState) => state.masterData.reviewStatus;

export const getEntityHierarchyPath = (state: RootState) =>
    state.archive.hierarchicalData.data?.path || null;
